// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiTransactionAPIModel,
    ApiTransactionAPIModelFromJSON,
    ApiTransactionAPIModelFromJSONTyped,
    ApiTransactionAPIModelToJSON,
    PageV1APIModel,
    PageV1APIModelFromJSON,
    PageV1APIModelFromJSONTyped,
    PageV1APIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface TransactionsSliceAPIModel
 */
export interface TransactionsSliceAPIModel {
    /**
     * 
     * @type {Array<ApiTransactionAPIModel>}
     * @memberof TransactionsSliceAPIModel
     */
    transactions?: Array<ApiTransactionAPIModel>;
    /**
     * 
     * @type {PageV1APIModel}
     * @memberof TransactionsSliceAPIModel
     */
    page: PageV1APIModel;
    /**
     * 
     * @type {number}
     * @memberof TransactionsSliceAPIModel
     */
    total: number;
}

export function TransactionsSliceAPIModelFromJSON(json: any): TransactionsSliceAPIModel {
    return TransactionsSliceAPIModelFromJSONTyped(json, false);
}

export function TransactionsSliceAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsSliceAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : ((json['transactions'] as Array<any>).map(ApiTransactionAPIModelFromJSON)),
        'page': PageV1APIModelFromJSON(json['page']),
        'total': json['total'],
    };
}

export function TransactionsSliceAPIModelToJSON(value?: TransactionsSliceAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': value.transactions === undefined ? undefined : ((value.transactions as Array<any>).map(ApiTransactionAPIModelToJSON)),
        'page': PageV1APIModelToJSON(value.page),
        'total': value.total,
    };
}


